import React from "react";
import { Tabs, Tab } from "material-ui/Tabs";
import CategorizedOptionList from "../components/CategorizedOptionList";
import CaveatListEditor from "../components/CaveatListEditor";
import shallowCompare from "react-addons-shallow-compare";
import PropTypes from "prop-types";
import NewCategorizedOptionList from "./CategorizedItemList";
import ListItem from "material-ui/List/ListItem";
import CriteriaDialog from "./CriteriaDialog";
import { CardText } from "material-ui";

let saveRefs = (store, key) => {
  return val => {
    store.set(key, val);
  };
};

let domainBgStyle = { backgroundColor: "white", color: "black" };
let tabContainerBgStyle = { backgroundColor: "#d8d8d8", color: "black" };
let tabSubContainerBgStyle = {
  ...tabContainerBgStyle,
  backgroundColor: "#efefef"
};

//TODO: use one name mapping throughout
const SECTIONS = [
  { label: "Data Collection", id: "monitoring" },
  { label: "Assessment", id: "assessment" },
  { label: "Management Measures", id: "controlRules" },
  { label: "Enforcement", id:"enforcement"}
];

let getSelectedIndex = (options, domainLogic) => {
  for (let option of options) {
    let caveat = domainLogic.caveats[option.id];
    let criterion = domainLogic.criteria[option.id];
    if (caveat) {
      return 1;
    } else if (criterion) {
      return 0;
    }
  }
  return NaN;
};

// const AnswerCount = ({ option, domainLogic }) => {
//   const count = domainLogic.criteria[option.id]
//     ? domainLogic.criteria[option.id].length
//     : 0;
//   if (count) {
//     return `${count} matching answer${count !== 1 ? "s" : ""}`;
//   } else {
//     return "";
//   }
// };

class QuestionDomainLogicSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      domainLogic: props.domainLogic,
      criteriaDialogOpen: false
    };
    this._caveatOptionLists = new Map();
    this._criteriaOptionLists = new Map();
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  handleCriteriaDialogSave(criteria, optionID) {
    const newDomainLogic = {
      ...this.state.domainLogic
    };
    newDomainLogic.criteria = newDomainLogic.criteria || {};
    newDomainLogic.criteria[optionID] = criteria;
    this.setState({ domainLogic: newDomainLogic, criteriaDialogOpen: false });
  }

  render() {
    let sections = SECTIONS.map(section => {
      let options = this.props.options.filter(t => t.section === section.id);
      return {
        ...section,
        selectedIndex: getSelectedIndex(options, this.state.domainLogic),
        options: options
      };
    });

    var tabsInitialSelectedIndex = 0;
    for (var i = 0; i < sections.length; i++) {
      if (sections[i].selectedIndex >= 0) {
        tabsInitialSelectedIndex = i;
        break;
      }
    }

    let props = this.props;

    // If any domain logic is active for an option within a given category,
    // that category header should display an "indicator light"
    const shouldShowCriteriaIndicator = options => {
      if (this.state.domainLogic && this.state.domainLogic.criteria) {
        for (const option of options) {
          if (hasActiveCriteria(option)) {
            return true;
          }
        }
      }
      return false;
    };

    const hasActiveCriteria = option => getCriteria(option).length > 0;

    const getCriteria = option => {
      if (this.state.domainLogic && this.state.domainLogic.criteria) {
        return this.state.domainLogic.criteria[option.id] || [];
      } else {
        return [];
      }
    };

    // const hasActiveCaveats = option => {
    //   const caveats = getCaveats(option);
    //   return Object.keys(caveats).length > 0
    // }
    //
    // const getCaveats = option => {
    //   if (this.state.domainLogic && this.state.domainLogic.caveats) {
    //     return this.state.domainLogic.caveats[option.id] || {};
    //   } else {
    //     return {};
    //   }
    // }
    //
    // const shouldShowCaveatsIndicator = options => {
    //   if (this.state.domainLogic && this.state.domainLogic.criteria) {
    //     for (const option of options) {
    //       if (hasActiveCaveats(option)) {
    //         return true;
    //       }
    //     }
    //   }
    //   return false;
    // }

    return (
      <Tabs
        inkBarStyle={{ backgroundColor: "black" }}
        tabItemContainerStyle={domainBgStyle}
        initialSelectedIndex={tabsInitialSelectedIndex}
      >
        {sections.map(section => {
          return (
            <Tab
              key={section.id}
              style={tabContainerBgStyle}
              label={section.label}
            >
              <Tabs
                inkBarStyle={{ backgroundColor: "rgb(63, 178, 198)" }}
                tabItemContainerStyle={domainBgStyle}
                initialSelectedIndex={section.selectedIndex}
              >
                <Tab style={tabSubContainerBgStyle} label="Criteria">
                  <CardText>Click on an option to add or change criteria.</CardText>
                  <NewCategorizedOptionList
                    showIndicator={shouldShowCriteriaIndicator}
                    expandable={true}
                    categories={props.categories}
                    items={section.options}
                  >
                    {option => {
                      const criteria = getCriteria(option);
                      return (
                        <ListItem
                          key={option.id}
                          onClick={() =>
                            this.setState({ criteriaDialogOpen: option.id })
                          }
                          style={
                            criteria.length
                              ? {
                                  // textDecoration: "underline",
                                  fontWeight: 500
                                  // textDecorationColor: "#34a4ef"
                                }
                              : { color: "grey" }
                          }
                          primaryText={
                            <span>
                              {option.title}{" "}
                              <span
                                style={{
                                  display: criteria.length ? "inline" : "none",
                                  marginLeft: 10,
                                  textShadow: "1px 1px 1px #00000069",
                                  backgroundColor: "#6db2d9",
                                  color: "white",
                                  padding: "4px 6px",
                                  borderRadius: 3,
                                  lineHeight: "32px",
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                {criteria.length
                                  ? `${criteria.length} criteria answers`
                                  : ""}
                              </span>
                            </span>
                          }
                        />
                      );
                    }}
                  </NewCategorizedOptionList>
                  {this.state.criteriaDialogOpen ? (
                    <CriteriaDialog
                      onSave={criteria =>
                        this.handleCriteriaDialogSave(
                          criteria,
                          this.state.criteriaDialogOpen
                        )
                      }
                      onClose={() =>
                        this.setState({ criteriaDialogOpen: false })
                      }
                      open={true}
                      criteria={
                        (this.state.domainLogic.criteria || [])[
                          this.state.criteriaDialogOpen
                        ]
                      }
                      questions={this.props.questions}
                    />
                  ) : (
                    ""
                  )}
                </Tab>
                <Tab style={tabSubContainerBgStyle} label="Caveats">
                  <CategorizedOptionList
                    ref={saveRefs(this._caveatOptionLists, section.id)}
                    categories={props.categories}
                    options={section.options}
                  >
                    <CaveatListEditor
                      answers={props.answers}
                      domainLogic={this.state.domainLogic}
                    />
                  </CategorizedOptionList>
                </Tab>
              </Tabs>
            </Tab>
          );
        })}
      </Tabs>
    );
  }

  handleListUpdate(id, state, option) {
    const optionCaveats = this.state.domainLogic.caveats[option.id] || {};
    if (state.title && state.title.length) {
      optionCaveats[id] = {
        title: state.title,
        score: state.score,
      };
      this.state.domainLogic.caveats[option.id] = optionCaveats;
      this.setState({domainLogic: {
        ...this.state.domainLogic
      }});
    } else {

      delete optionCaveats[id];
      this.state.domainLogic.caveats[option.id] = optionCaveats;
      this.setState({domainLogic: {
        ...this.state.domainLogic
      }});

    }
  }

  getValue() {
    let caveatListEditors = [];
    for (let [key, list] of this._caveatOptionLists) {
      caveatListEditors = caveatListEditors.concat(list.getChildren());
    }
    let newDomainLogic = {
      criteria: this.state.domainLogic.criteria,
      caveats: caveatListEditors.reduce((logic, editor) => {
        // if (editor.hasChanged()) {
          const value = editor.getValue();
          if (Object.keys(value).length > 0) {
            logic[editor.props.optionID] = value;
          }
        // }
        return logic;
      }, {})
    };
    return newDomainLogic;
  }
}

QuestionDomainLogicSettings.propTypes = {
  domainLogic: PropTypes.shape({
    caveats: PropTypes.object.isRequired,
    criteria: PropTypes.object.isRequired
  }).isRequired,
  options: PropTypes.array.isRequired,
  categories: PropTypes.array.isRequired,
  answers: PropTypes.array.isRequired,
  onChange: PropTypes.func
};

export default QuestionDomainLogicSettings;
